import { useMutation } from '@frontend/react-query-helpers';
import { updatePayoutDescriptor } from './api';
import { useInvalidateQueries } from './payout-descriptor-query';

export type UseUpdatePayoutDescriptorProps = {
  locationId: string;
  onSuccess?: () => void;
  onError?: () => void;
};
export const useUpdatePayoutDescriptor = ({ locationId, onSuccess, onError }: UseUpdatePayoutDescriptorProps) => {
  const { invalidatePayoutQueryDescriptor } = useInvalidateQueries();
  return useMutation({
    mutationFn: ({ descriptor }: { descriptor: string }) => updatePayoutDescriptor({ locationId, descriptor }),
    onSuccess: () => {
      invalidatePayoutQueryDescriptor([locationId]);
      onSuccess?.();
    },
    onError: () => {
      onError?.();
    },
  });
};
